import { Skeleton } from "@/components/ui/skeleton";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { PhoneCall } from "lucide-react";
import React from "react";
import { WidgetTitle } from "@/components/widgets/WidgetTitle";

interface UserCallsHandledWidgetProps {
  loading?: boolean;
  data?: { handled: number; missed: number; missedPct: number } | null;
}

const UserCallsHandledWidget: React.FC<UserCallsHandledWidgetProps> = ({ loading, data }) => (
  <div className="w-full min-w-[200px] rounded-lg border flex flex-col bg-white dark:bg-[#0C3451] dark:text-white dark:border-[#0C3451] p-3">
    <div className="flex flex-row items-center justify-between">
      <WidgetTitle className="truncate">Calls handled</WidgetTitle>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <span className="cursor-pointer">
              <PhoneCall className="h-4 w-4 text-primary dark:text-white" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="top">
            <p className="max-w-xs text-xs">The total number of calls handled, along with missed calls and their percentage within given time</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
    <div>
      {loading ? (
        <Skeleton className="h-16 w-full" />
      ) : (
        <div className="flex items-baseline gap-2 my-2">
          <span className="text-[24px] font-[700] text-brand-navy">
            {data?.handled ?? 0}
          </span>
          <span className="text-[12px] text-destructive">
            {data?.missed ?? 0} missed ({data?.missedPct ?? 0}%)
          </span>
        </div>
      )}
    </div>
  </div>
);

export default UserCallsHandledWidget;
